import Anounce from '@/components/Anounce';
// import NewAnounce from '@/components/NewAnounce';
// import EditAnounce from '@/components/EditAnounce';
// import Adminka from '@/components/Adminka';
import Video from '@/components/Video';
import Member from '@/components/Member';
// import Contacts from '@/components/Contacts';
// import Photo from '@/components/Photo';


const routes = [
  {
    path: '/anounces',
    name: 'Anounce',
    component: Anounce
  },
  /*
  {
    path: 'newanounces',
    name: 'NewAnounce',
    component: NewAnounce
  },
  {
    path: 'editanounces',
    name: 'EditAnounce',
    component: EditAnounce
  },
  
  {
    path: '/adminka',
    name: 'Adminka',
    component: Adminka,
  },
  */
  {
    path: '/videos',
    name: 'Video',
    component: Video,
  },
  {
    path: '/members',
    name: 'Member',
    component: Member,
  },
  /*
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts,
  },
  */
/*
{
    path: 'photos',
    name: 'Photo',
    component: Photo,
  },
  */
]
export default routes
